<template>
  <div id="cems-sync-log" class="cems-sync-log__container">
    <!-- <div class="page-header"> -->
    <!-- <div class="h5">SISPEK synchronization logs</div> -->
    <b-row>
      <b-col md="8" class="py-3">
        <div id="b-calendar" class="b-calendar">
          <div class="b-calendar__calendar">
            <div class="b-calendar__header">
              <b-row align-v="center">
                <b-col sm="3" v-if="hasLicense(['siplah'])">
                  <div class="d-flex" style="align-items: center;">
                    <span style="font-size: 16px;" class="mr-2"
                      ><strong>Server</strong></span
                    >
                    <b-form-select
                      :options="['SISPEK', 'SIPLAH']"
                      v-model="selectedServer"
                      size="sm"
                    >
                    </b-form-select>
                  </div>
                </b-col>
                <b-col sm="3">
                  <div class="d-flex" style="align-items: center;">
                    <span style="font-size: 16px;" class="mr-2"
                      ><strong>Chimney</strong></span
                    >
                    <b-form-select
                      :options="stacks"
                      text-field="name"
                      value-field="uid"
                      v-model="selectedStack"
                      size="sm"
                    >
                    </b-form-select>
                    <!-- <v-select
                      :options="stacks"
                      :state="false"
                      textProp="name"
                      valueProp="uid"
                      :reduce="(stack) => stack.uid"
                      v-model="selectedStack"
                    /> -->
                    <!-- <b-button
                      variant="info"
                      size="sm"
                      class="mx-2"
                      aria-hidden="true"
                      @click="showMonthPicker"
                      >Scan</b-button
                    > -->
                  </div>
                </b-col>
                <b-col sm="6">
                  <b-row>
                    <b-col class="text-left" align-h="start">
                      <b-button
                        id="subtractMonthBtn"
                        class="arrow arrow-left"
                        variant="light"
                        @click="subtractMonth"
                      >
                        <i class="fa fa-fw fa-chevron-left"></i>
                      </b-button>
                      <b-tooltip target="subtractMonthBtn">
                        {{ previousMonthAsString | capitalize }}
                      </b-tooltip>
                    </b-col>
                    <b-col
                      class="d-flex"
                      style="align-items: center; justify-content: center;"
                    >
                      <!-- <span style="font-size: 16px; inline-size: max-content;"
                        ><strong>{{ month }}</strong
                        >, <strong>{{ year }}</strong></span
                      > -->
                      <el-date-picker
                        v-model="monthPicker"
                        @change="onPickerChange"
                        ref="month-picker"
                        format="MMMM, yyyy"
                        format-value="timestamp"
                        type="month"
                        align="center"
                        placeholder="Pick a month"
                      />
                    </b-col>
                    <b-col
                      class="text-right d-flex flex-row-reverse"
                      align-h="end"
                    >
                      <b-button
                        id="addMonthBtn"
                        class="arrow arrow-right"
                        variant="light"
                        @click="addMonth"
                      >
                        <i class="fa fa-fw fa-chevron-right"></i>
                      </b-button>
                      <b-tooltip target="addMonthBtn">
                        {{ nextMonthAsString | capitalize }}
                      </b-tooltip>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
            <div class="b-calendar__weekdays">
              <div
                class="weekday text-center"
                v-for="(day, index) in days"
                :key="index"
              >
                <strong>{{ day }}</strong>
              </div>
            </div>
            <div class="b-calendar__dates">
              <div
                v-for="date in dateList"
                class="date text-right"
                :class="{
                  active: selectedDate.unix() === date.moment.unix(),
                  blank: date.blank,
                  'no-border-right': date.key % 7 === 0,
                }"
                :key="date.key"
                :data-date="date.date"
                @click="setSelectedDate(date.moment)"
              >
                <span class="day">{{ date.dayNumber }}</span>
                <span class="weekday">{{ date.weekDay }}</span>
                <div
                  v-if="!date.blank"
                  class="d-flex"
                  style="height: calc(100% - 16px); align-items: center; justify-content: center;"
                >
                  <!-- sync tidak lengkap -->
                  <div
                    v-if="
                      (date.today && date.syncTotal < currentHour) ||
                        (date.passed && date.syncTotal < 24)
                    "
                    :class="date.syncFailed ? 'mr-2' : ''"
                    style="position: relative; font-size: xx-large;"
                  >
                    <b-icon-cloud-slash class="text-warning" />
                    <span v-if="!date.today" class="icon-badge">{{
                      24 - date.syncTotal
                    }}</span>
                    <span v-else class="icon-badge">{{
                      currentHour - date.syncTotal
                    }}</span>
                  </div>

                  <div style="position: relative; font-size: xx-large;">
                    <!-- today -->
                    <b-icon-cloud-arrow-up
                      v-if="date.today && date.syncTotal"
                      :class="date.syncFailed ? 'text-warning' : 'text-success'"
                    />
                    <!-- succes 24 data -->
                    <b-icon-cloud-check
                      v-else-if="date.syncTotal === 24 && date.syncFailed === 0"
                      class="text-success"
                    />
                    <!-- terdapat gagal -->
                    <b-icon-cloud-minus
                      v-else-if="date.syncFailed"
                      class="text-warning"
                    />
                    <span v-if="date.syncFailed" class="icon-badge">{{
                      date.syncFailed
                    }}</span>
                  </div>
                </div>
                <div class="additional" v-show="date.additional">
                  <span class="year" v-show="date.additional.year">{{
                    date.additional.year
                  }}</span>
                  <span class="month" v-show="date.additional.month">{{
                    date.additional.month
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col
        md="4"
        class="custom-scrollbar"
        style="height: 100%; overflow: auto;"
      >
        <timeline
          v-if="timeline.length"
          class="my-3"
          :items="timeline"
        ></timeline>
        <div
          v-else
          class="d-flex"
          style="height: calc(100% - 16px); align-items: center; justify-content: center;"
        >
          <input type="image" src="/img/no_data.png" alt="No data found" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'

import Timeline from './timeline/index.vue'

import {
  FindStacks,
  FindSiplahTimeline,
  FindSiplahLogsMonthly,
  FindSispekTimeline,
  FindSispekLogsMonthly,
} from '@/api/cems'

export default Vue.extend({
  components: { Timeline },
  name: 'SyncLog',

  data() {
    return {
      stacks: [],
      selectedServer: 'SISPEK',
      stackOptions: [],
      selectedStack: '',
      syncLogs: [],
      monthPicker: '',

      today: moment(),
      dateContext: moment().startOf('day'),
      selectedDate: moment().startOf('day'),
      days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      timeline: [],
    }
  },

  computed: {
    ...mapState(['license']),
    year() {
      return this.dateContext.format('Y')
    },

    month() {
      return this.dateContext.format('MMMM')
    },

    monthNumber() {
      return this.dateContext.format('MM')
    },

    daysInMonth() {
      return this.dateContext.daysInMonth()
    },

    currentDate() {
      return this.dateContext.get('date')
    },

    firstDayOfMonth() {
      const firstDay = moment(this.dateContext).subtract(
        this.currentDate,
        'days'
      )
      return firstDay.weekday()
    },

    previousMonth() {
      return moment(this.dateContext).subtract(1, 'month')
    },

    previousMonthAsString() {
      return this.previousMonth.format('MMMM')
    },

    nextMonth() {
      return moment(this.dateContext).add(1, 'month')
    },

    nextMonthAsString() {
      return this.nextMonth.format('MMMM')
    },

    daysInPreviousMonth() {
      return this.previousMonth.daysInMonth()
    },

    daysFromPreviousMonth() {
      const daysList = []
      let count = this.daysInPreviousMonth - this.firstDayOfMonth
      while (count < this.daysInPreviousMonth) {
        count++
        daysList[count] = count
      }

      return daysList.filter(function() {
        return true
      })
    },

    dateList() {
      const dateList = []

      const previousMonth = this.previousMonth
      const nextMonth = this.nextMonth

      //dates for display
      const formattedCurrentMonth = this.dateContext.format('MM')
      const formattedCurrentYear = this.year
      const formattedPreviousMonth = previousMonth.format('MM')
      const formattedPreviousYear = previousMonth.format('Y')
      const formattedNextMonth = nextMonth.format('MM')
      const formattedNextYear = nextMonth.format('Y')

      //counters
      let countDayInCurrentMonth = 0
      let countDayInPreviousMonth = 0

      const formattingDay = this.formattingDay
      const daysFromPreviousMonth = this.daysFromPreviousMonth
      const previousMonthAsString = this.previousMonthAsString
      //filling in dates from the previous month
      this.daysFromPreviousMonth.forEach(function(dayFromPreviousMonth) {
        countDayInCurrentMonth++
        countDayInPreviousMonth++

        const formattedDay = formattingDay(dayFromPreviousMonth)
        const previousMonth =
          daysFromPreviousMonth.length === countDayInPreviousMonth
            ? previousMonthAsString
            : false
        const previousYear =
          formattedCurrentYear !== formattedPreviousYear &&
          daysFromPreviousMonth.length === countDayInPreviousMonth
            ? formattedPreviousYear
            : false
        let additional = {
          month: previousMonth,
          year: previousYear,
        }

        if (!previousMonth && !previousYear) {
          additional = false
        }

        dateList[countDayInCurrentMonth] = {
          key: countDayInCurrentMonth,
          dayNumber: formattedDay,
          date:
            formattedDay +
            '.' +
            formattedPreviousMonth +
            '.' +
            formattedPreviousYear,
          blank: true,
          today: false,
          additional: additional,
          weekDay: false,
          moment: moment(
            formattedPreviousYear + formattedPreviousMonth + formattedDay
          ),
        }
      })

      //filling in dates from the current month
      while (countDayInCurrentMonth < this.firstDayOfMonth + this.daysInMonth) {
        countDayInCurrentMonth++

        const day = countDayInCurrentMonth - countDayInPreviousMonth
        const weekDay = this.getWeekDay(countDayInCurrentMonth)
        const formattedDay = this.formattingDay(day)

        let syncTotal = 0
        let syncFailed = 0
        const syncData = this.syncLogs.find(
          (item) => item.dayOfMonth === formattedDay
        )
        if (syncData) {
          syncTotal = syncData.successCount + syncData.failedCount
          syncFailed = syncData.failedCount
        }

        const momentData = moment(
          formattedCurrentYear + formattedCurrentMonth + formattedDay
        )

        dateList[countDayInCurrentMonth] = {
          key: countDayInCurrentMonth,
          dayNumber: formattedDay,
          date:
            formattedDay +
            '.' +
            formattedCurrentMonth +
            '.' +
            formattedCurrentYear,
          blank: false,
          today:
            formattedDay === this.initialDate &&
            this.todayInCurrentMonthAndYear,
          additional: false,
          weekDay: weekDay,
          moment: momentData,
          passed: momentData.unix() < this.today.unix(),
          syncTotal: syncTotal,
          syncFailed: syncFailed,
        }
      }

      const daysInNextMonth = 7 - (countDayInCurrentMonth % 7)
      const countDayInCurrentMonthSaved = countDayInCurrentMonth
      let day = 0

      //filling in dates from the next month
      if (daysInNextMonth < 7) {
        while (
          countDayInCurrentMonth <
          countDayInCurrentMonthSaved + daysInNextMonth
        ) {
          countDayInCurrentMonth++
          day++

          const formattedDay = this.formattingDay(day)
          const nextMonth = day === 1 ? this.nextMonthAsString : false
          const nextYear =
            formattedCurrentYear !== formattedNextYear && day === 1
              ? formattedNextYear
              : false
          let additional = {
            month: nextMonth,
            year: nextYear,
          }

          if (!nextMonth && !nextYear) {
            additional = false
          }

          dateList[countDayInCurrentMonth] = {
            key: countDayInCurrentMonth,
            dayNumber: formattedDay,
            date:
              formattedDay + '.' + formattedNextMonth + '.' + formattedNextYear,
            blank: true,
            today: false,
            additional: additional,
            weekDay: false,
            moment: moment(
              formattedNextYear + formattedNextMonth + formattedDay
            ),
          }
        }
      }

      return dateList.filter(function() {
        return true
      })
    },

    initialDate() {
      return this.formattingDay(this.today.get('date'))
    },

    initialMonth() {
      return this.today.format('MMMM')
    },

    initialYear() {
      return this.today.format('Y')
    },

    todayInCurrentMonthAndYear() {
      return this.month === this.initialMonth && this.year === this.initialYear
    },

    selectedDayAndMonth() {
      let dayAndMonth = this.selectedDate.format('D MMMM')
      dayAndMonth = dayAndMonth.split(' ')
      dayAndMonth = {
        day: dayAndMonth[0],
        month: dayAndMonth[1],
      }

      return dayAndMonth
    },

    selectedWeekDay() {
      return this.selectedDate.format('dddd')
    },

    todayIsEqualSelectDate() {
      return (
        this.selectedDate.format('YYYYMMDD') === this.today.format('YYYYMMDD')
      )
    },

    currentHour() {
      return moment().format('H')
    },
  },

  methods: {
    hasLicense(license) {
      if (typeof license == 'undefined') {
        return true
      }

      for (const lic of license) {
        if (this.license.detailLicense[lic]) {
          return true
        }
      }

      return false
    },

    async findStacks() {
      this.stacks = await FindStacks()
      if (this.stacks.length > 0) {
        this.selectedStack = this.stacks[0].uid
      }
    },

    addMonth() {
      this.dateContext = this.nextMonth
      this.monthPicker = this.dateContext.startOf('day')
    },

    subtractMonth() {
      this.dateContext = this.previousMonth
      this.monthPicker = this.dateContext.startOf('day')
    },

    async setSelectedDate(moment) {
      const newMonth = moment.format('MMMM')
      if (newMonth === this.month) {
        this.selectedDate = moment
        await this.getTimeline()
      }
    },

    goToday() {
      this.selectedDate = this.today
      this.dateContext = this.today
    },

    formattingDay(day) {
      return ('0' + day).slice(-2)
    },

    getWeekDay(day) {
      let index = day
      if (index > 7) {
        index %= 7
      }
      index = index === 0 ? 6 : index - 1
      return this.days[index]
    },

    async setSyncLog() {
      this.syncLogs = []

      let response
      const dt = moment(`${this.year}-${this.monthNumber}`, 'YYYY-MM').toDate()
      switch (this.selectedServer) {
        case 'SISPEK':
          response = await FindSispekLogsMonthly(this.selectedStack, dt)
          this.syncLogs = response
          break
        case 'SIPLAH':
          response = await FindSiplahLogsMonthly(this.selectedStack, dt)
          this.syncLogs = response
          break
      }
    },

    async getTimeline() {
      const timeline = []

      const selectedDay = this.selectedDate.format('DD')
      const syncData = this.syncLogs.find(
        (item) => item.dayOfMonth === selectedDay
      )

      if (syncData) {
        let response

        switch (this.selectedServer) {
          case 'SISPEK':
            response = await FindSispekTimeline(
              this.selectedStack,
              this.selectedDate.toDate()
            )
            break
          case 'SIPLAH':
            response = await FindSiplahTimeline(
              this.selectedStack,
              this.selectedDate.toDate()
            )
            break
        }

        if (response.length) {
          let currentDataTime = ''
          response.map((item) => {
            if (currentDataTime !== item.log.dataTime) {
              currentDataTime = item.log.dataTime
              item.splitter = true
            }

            item.createdAt = moment(item.createdAt).format(
              'D MMM YYYY - HH:mm:ss'
            )

            item.dataTime = moment(item.log.dataTime).format('HH:00 ~ HH:59')

            timeline.push(item)
          })
        }
      }

      this.timeline = timeline
    },

    showMonthPicker() {
      const picker = this.$refs['month-picker']
      picker.focus()
    },

    onPickerChange() {
      this.dateContext = moment(this.monthPicker)
    },
  },

  filters: {
    capitalize(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },

  async created() {
    await this.findStacks()

    this.monthPicker = this.today.startOf('day')
    const picker = this.$refs['month-picker']
    picker.$el.children[0].setAttribute('readonly', true)
  },

  events: {
    'timeline-delete-item': function() {
      // this.timeline = _.remove(this.timeline, function(item) {
      //   return item.id != id
      // })
    },
  },

  watch: {
    selectedServer: async function() {
      await this.setSyncLog()
      await this.getTimeline()
    },
    selectedStack: async function() {
      await this.setSyncLog()
      await this.getTimeline()
    },

    month: async function() {
      await this.setSyncLog()
    },
  },
})
</script>

<style lang="sass">
@import './assets/calendar.sass'
.el-date-picker
  .popper__arrow
    left: 50% !important

table.el-month-table
  td.today
    .cell
      color: unset
      font-weight: unset

table.el-year-table
  td.today
    .cell
      color: unset
      font-weight: unset

.cems-sync-log__container
  .el-date-editor
    input
      border: 0
      outline: none
      padding: 0
      text-align: center
      font-weight: bold
      font-size: 16px
      cursor: pointer
    span
      display: none

  .custom-scrollbar
    @media (max-width: 768px)
      height: calc(100% - 483px) !important

      .date.text-right
        div.d-flex
          div
            font-size: x-large !important

      .icon-badge
        font-size: 7px !important
</style>
